<template>
  <b-container class="blog-post">
    <b-row>
      <b-col md="10" offset="1">

        <br>

        <p class="blog-date">03/14/18</p>
        <h1>March Break Madness: Activities Kids (And Parents) Will Love!</h1>
        <br>
        <div class="blog-content">
        <p>The sun is out and so is school, and Pickering has a ton of amazing activities to
          keep little hands busy(and out of your hair). We’ve put together a list of the best places to explore around
          the New Seaton community, perfect for kids of all ages!</p>

        <br>

        <b-img fluid src="/img/blogs/new-seaton-march-break-madness-activities-kids-will-love-01.jpg" alt="Child lying down" class="mb-15" />
        <p class="subtitle">GET ACTIVE</p>
        <p class="sub-title">Pickering Athletic Centre</p>
        <p>If your kids never stop moving, then taking advantage of the Pickering Athletic
          Centre’s selection of march break camps may just be your saving grace! They offer flexible and fun programs
          ranging from full week camps, half day camps, and even single day camps, so you can pick and choose what
          works with your schedule. Plus, the single day camps are great for letting your child try something
          completely new while still remaining risk-free.</p>
        <a href="http://pickeringathleticcentre.com/march-break-camp/" target="_blank" class="blog-readmore">Learn More</a>

        <br><br><br>

        <b-img fluid src="/img/blogs/new-seaton-march-break-madness-activities-kids-will-love-02.jpg" alt="Three flasks with elements mixed in them" class="mb-15" />
        <p class="subtitle">LEARN A THING OR TWO</p>
        <p class="sub-title">OPG March Break Madness 2018</p>
        <p>If your kids never stop moving, then taking advantage of the Pickering Athletic
          Centre’s selection of march break camps may just be your saving grace! They offer flexible and fun programs
          ranging from full week camps, half day camps, and even single day camps, so you can pick and choose what
          works with your schedule. Plus, the single day camps are great for letting your child try something
          completely new while still remaining risk-free.</p>
        <a href="https://www.opg.com/Pages/home.aspx" target="_blank" class="blog-readmore">Read More</a>


        <br><br><br>

        <b-img fluid src="/img/blogs/new-seaton-march-break-madness-activities-kids-will-love-03.jpg" alt="2 kids standing outside in the woods" class="mb-15" />
        <p class="subtitle">EXPLORE THE OUTDOORS</p>
        <p class="sub-title">Amberlea Park</p>
        <p>If you’re just itching to get outside, then Amberlea Park is the perfect place
          that will keep your kids happy (and occupied!). Whether it’s rain or shine, their playground, 400M track,
          and selection of sports fields are more than enough to get them tuckered out after a visit—letting parents
          enjoy some much-needed quiet time.</p>
        <a href="https://apps.pickering.ca/knowledgebase/ParkDetails.aspx?ParkFacilityID=4" target="_blank" class="blog-readmore">Learn More</a>

        <br><br><br>

        <b-img fluid src="/img/blogs/new-seaton-march-break-madness-activities-kids-will-love-04.jpg" alt="Bowling ball moments before hitting bowling pins" class="mb-15" />

          <p class="subtitle">GET IN THE GAME</p>
          <p class="sub-title">NEB’s Fun World</p>
          <p>Just a short drive east can transport you to a place that is 100% dedicated to
            FUN! Complete with a bowling alley, play centre, theme-park inspired rides, full arcade, and more, there’s
            something for everyone to do at NEB’s. Plus, you can take advantage of an incredible 1/2 ticket special
            from March 12-March 16 for even better value on ticket rides and games.</p>
          <a href="https://nebsfunworld.com/" target="_blank" class="blog-readmore">Learn More</a>


        <br><br><br>

        <b-img fluid src="/img/blogs/new-seaton-march-break-madness-activities-kids-will-love-05.jpg" alt="Panda sitting high on a tree" class="mb-15" />

        <p class="subtitle">GO BUCK WILD</p>
        <p class="sub-title">The Toronto Zoo</p>
        <p>No march break is complete without a trip to the zoo, and it’s the perfect time
          to catch the Chinese giant pandas before they pack their bags for Calgary! Filled with over 5,000 animals
          and 250 different species, the zoo has tons of different exhibits that are both engaging and educational
          for kids of all ages. The best part is, getting from Pickering to Toronto is only a 38 minute drive from
          home in New Seaton!</p>
<a href="http://www.torontozoo.com/pandas/" target="_blank" class="blog-readmore">Learn More</a>
        <br><br><br>

</div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  export default {
    transition: {
      mode: 'out-in',
      css: false,
      appear: true,

      enter(el, done) {
        this.$root.layout.methods.triggerBlogEnterAnimation(done)
      },
      leave(el, done) {
        this.$root.layout.methods.triggerBlogLeaveAnimation(done)
      },
    },
  }

</script>

<style scoped>

</style>